import { Dispatch } from "redux";
import axios from "axios";
import {JackpotTrackingAction, JackpotTrackingActionTypes} from "../../types/Jackpot/jackpotTrackingTypes";

interface ErrorResponse {
    code: number;
    message: string;
}

export const trackingJackpots = (code: string): any => {
    return async (dispatch: Dispatch<JackpotTrackingAction>) => {
        try {
            dispatch({ type: JackpotTrackingActionTypes.FETCH_JACKPOT_TRACKING_DATA });
            const response = await axios({
                method: 'get',
                url: `/api/tickets/${code}`,
                withCredentials: false
            });
            dispatch({ type: JackpotTrackingActionTypes.FETCH_JACKPOT_TRACKING_DATA_SUCCESS, payload: response.data });
        } catch (error: any) {
            let errorPayload: ErrorResponse;
            if (error.response && error.response.data) {
                const { code, message } = error.response.data;
                errorPayload = { code, message };
            } else {
                errorPayload = { code: -1, message: 'Unknown error occurred' };
            }
            dispatch({ type: JackpotTrackingActionTypes.FETCH_JACKPOT_TRACKING_DATA_ERROR, payload: errorPayload });
        }
    }
}
